import RenderHTML from '../../ui-components/RenderHTML'

export const CloseButton = ({ onClose }: { onClose: () => void }) => {
  return (
    <div onClick={onClose}>
      <RenderHTML innerHTMLText={CLOSE_BUTTON} />
    </div>
  )
}

const CLOSE_BUTTON = `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
  <circle cx="18" cy="18" r="18" fill="#187BC9"/>
  <rect width="2.19934" height="17.5947" rx="1.09967" transform="matrix(0.707037 0.707177 -0.707037 0.707177 23.4375 11)" fill="white"/>
  <rect width="2.19934" height="17.5947" rx="1.09967" transform="matrix(-0.707037 0.707177 -0.707037 -0.707177 25 23.4473)" fill="white"/>
</svg>`
